// extracted by mini-css-extract-plugin
module.exports =  {"dropdown":"I9DEpRDeb5WrH7TtHSfv","item":"NYCt591fcR8jNOfaATlY"};